(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9716],{

/***/ 33716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);
var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

var SvgNotFound = function SvgNotFound(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 228 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    clipPath: "url(#notFound_svg__clip0_2665_101767)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m207.959 146.567-6.511-19.543s7.163 7.123 7.163 12.967l-1.287-13.515s3.674 4.93 3.308 12.419c-.367 7.488-2.673 7.672-2.673 7.672ZM68.112 128.772l-6.35-19.075s6.99 6.954 6.99 12.657l-1.255-13.203s3.587 4.814 3.227 12.121c-.361 7.307-2.612 7.5-2.612 7.5Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M167.315 137.571c0 12.548-25.014 8.688-55.647 8.714-30.632.026-55.28 3.929-55.291-8.611-.012-12.539 25.005-15.297 55.638-15.323 30.633-.026 55.288 2.675 55.3 15.22Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M228 146.28H0v.574h228v-.574Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M145.845 120.629h-4.006l-1.905-15.363h5.911v15.363Z",
    fill: "#A0616A"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M138.531 119.49h8.168v4.836h-12.583v-.442c0-1.164.465-2.282 1.293-3.106a4.431 4.431 0 0 1 3.122-1.288Z",
    fill: "#042E42"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M175.283 143.303h-4.006l-1.905-15.364h5.911v15.364Z",
    fill: "#A0616A"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M167.969 142.164h8.168V147h-12.583v-.442c0-1.165.465-2.282 1.293-3.106a4.431 4.431 0 0 1 3.122-1.288Z",
    fill: "#042E42"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M193.754 97.664a2.937 2.937 0 0 0 .344-3.27 2.967 2.967 0 0 0-.731-.898 3.17 3.17 0 0 0-.433-.287l-9.316-37.69-5.949 2.545 11.066 36.451a2.96 2.96 0 0 0-.164 2.098 2.981 2.981 0 0 0 1.273 1.681 3.006 3.006 0 0 0 3.91-.622v-.008ZM186.501 21.506a3.3 3.3 0 0 0-5.028.33l-14.395 1.645 2.19 5.522 13.091-2.437a3.32 3.32 0 0 0 4.324-.706 3.275 3.275 0 0 0-.182-4.354Z",
    fill: "#BA8E96"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m162.775 93.756 6.283 46.881 7.818-1.601s-1.154-34.155 2.759-38.265c3.914-4.11-5.027-11.32-5.027-11.32l-11.833 4.305Z",
    fill: "#042E42"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m165.372 80.84-2.886 4.306s-22.223-9.185-22.223 5.453c0 14.638-1.272 24.571-1.731 25.257-.459.686 5.322 2.466 8.081 2.009 0 0 3.405-23.598 3.174-24.97 0 0 21.799 10.62 25.94 9.713 4.142-.907 5.117-4.162 5.807-5.982.69-1.82-.288-16.36-.288-16.36l-13.799-4.187-2.075 4.762Z",
    fill: "#042E42"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m165.762 54.993-.822-.982s-9.213-20.616-5.594-26.17c3.62-5.553 19.412-6.383 19.914-6.056.503.328-1.189 4.57-.034 6.533 0 0-12.234 2.637-13.057 2.965-.822.327 6.349 12.419 6.349 12.419l-.822 7.364-5.934 3.927Z",
    fill: "#006863"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M181.886 44.846s-8.557.982-8.886.982c-.329 0-.493-2.127-.493-2.127l-7.568 10.31s-3.728 29.904-2.741 29.413c.987-.49 19.195 2.328 19.359 1.019.165-1.309-.164-7.853.329-8.18.494-.327 8.555-20.616 8.555-20.616s-.823-4.254-3.619-5.726c-2.797-1.473-4.936-5.075-4.936-5.075Z",
    fill: "#008785"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m187.808 52.865 2.633 2.781s3.91 31.962 1.772 32.944c-2.139.981-6.35.86-6.35.86l-4.141-15.15 6.086-21.435Z",
    fill: "#006863"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M173.664 42.823c4.182 0 7.573-3.372 7.573-7.531 0-4.16-3.391-7.531-7.573-7.531-4.183 0-7.573 3.372-7.573 7.531 0 4.16 3.39 7.531 7.573 7.531Z",
    fill: "#BA8E96"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M171.886 36.469c-.101-1.564-2.084-1.616-3.66-1.633-1.576-.018-3.463.043-4.346-1.249-.577-.86-.476-2.038 0-2.953.476-.916 1.287-1.619 2.075-2.296 2.02-1.745 4.127-3.482 6.566-4.593 2.438-1.11 5.299-1.57 7.83-.674 3.108 1.105 7.31 6.782 7.674 10.046.363 3.263-.95 6.6-3.161 9.023-2.21 2.423-7.267 1.455-10.45 2.322 1.937-2.724.661-7.672-2.439-8.943l-.089.95Z",
    fill: "#000505"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M104.395 133.881c10.04 0 18.18-8.095 18.18-18.079 0-9.985-8.14-18.08-18.18-18.08s-18.18 8.095-18.18 18.08c0 9.984 8.14 18.079 18.18 18.079ZM92.257 96.437c-2.52 0-4.986-.725-7.1-2.089a12.979 12.979 0 0 1-4.808-5.597L51.502 24.147a17.093 17.093 0 0 1-.137-13.612 17.168 17.168 0 0 1 3.954-5.732A17.28 17.28 0 0 1 61.233 1.1a17.354 17.354 0 0 1 13.672.673 17.254 17.254 0 0 1 5.518 4.265 17.144 17.144 0 0 1 3.366 6.091l20.889 67.567c.598 1.933.732 3.978.391 5.972a12.899 12.899 0 0 1-2.354 5.508 12.996 12.996 0 0 1-4.595 3.865 13.07 13.07 0 0 1-5.852 1.396h-.011Z",
    fill: "#008785"
  }))));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgNotFound);

/***/ }),

/***/ 30047:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[category]",
      function () {
        return __webpack_require__(331);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 24988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32852);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_common_BBadge__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24800);
/* harmony import */ var components_common_BImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69327);
/* harmony import */ var components_common_CurrencyText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95269);
/* harmony import */ var hooks_useBreakpoints__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43617);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88082);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26420);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32466);
/* harmony import */ var styles_ExperienceCard_module_css__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(97890);
/* harmony import */ var styles_ExperienceCard_module_css__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(styles_ExperienceCard_module_css__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48063);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10520);
/* harmony import */ var components_common_Favourited__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(76417);
/* harmony import */ var components_common_RatingStar__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(31399);
/* harmony import */ var utils_experience_experienceDuration_util__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(70379);
/* harmony import */ var states_useFavorite_store__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(80810);
/* harmony import */ var hooks_useFavorite__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(61356);
/* harmony import */ var states_useUserState__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(13253);
/* harmony import */ var next_translate_routes__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(22742);
/* harmony import */ var next_translate_routes__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(next_translate_routes__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var hooks_usePrevLink__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(3638);
/* harmony import */ var services_AnalyticsService__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(40515);
/* harmony import */ var services_LinkService__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(41824);
/* harmony import */ var hooks_useLocale__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(74021);

























var ExperienceCard = function(param) {
    var containerClass = param.containerClass, _isFirstImagePrioritized = param.isFirstImagePrioritized, isFirstImagePrioritized = _isFirstImagePrioritized === void 0 ? false : _isFirstImagePrioritized, experience = param.experience;
    var ref;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("common").t;
    var asPath = (0,next_translate_routes__WEBPACK_IMPORTED_MODULE_19__.useRouter)().asPath;
    var getPrevLink = (0,hooks_usePrevLink__WEBPACK_IMPORTED_MODULE_20__/* .usePrevLink */ .B)().getPrevLink;
    var isMobile = (0,hooks_useBreakpoints__WEBPACK_IMPORTED_MODULE_5__/* .useBreakpoint */ .G)().isMobile;
    var ref1 = (0,utils_experience_experienceDuration_util__WEBPACK_IMPORTED_MODULE_15__/* .getExperienceDurationByTime */ .x)(experience.duration), hour = ref1.hour, minute = ref1.minute;
    var isUserLoggedIn = (0,states_useUserState__WEBPACK_IMPORTED_MODULE_18__/* .useUserState */ .e)().isUserLoggedIn;
    var getExperienceFavorited = (0,states_useFavorite_store__WEBPACK_IMPORTED_MODULE_16__/* .useFavoriteStore */ .E)().getExperienceFavorited;
    var locale = (0,hooks_useLocale__WEBPACK_IMPORTED_MODULE_23__/* .useLocale */ .b)().locale;
    var analyticsPayload = (0,react__WEBPACK_IMPORTED_MODULE_8__.useMemo)(function() {
        return {
            experienceId: experience.id,
            experienceName: experience.title,
            experienceCategory: experience.type.value,
            regionTrName: experience.regionTRName,
            asPathOfPreviousPage: getPrevLink()
        };
    }, [
        experience,
        asPath
    ]);
    var isFavorited = isUserLoggedIn && (experience.isFavorited || getExperienceFavorited(experience.id));
    var ref2 = (0,hooks_useFavorite__WEBPACK_IMPORTED_MODULE_17__/* .useFavorite */ .s)(isFavorited, undefined, analyticsPayload), isCurrentFavorited = ref2.isCurrentFavorited, toggleExperienceFavorite = ref2.toggleExperienceFavorite;
    var sendAnalytics = function() {
        services_AnalyticsService__WEBPACK_IMPORTED_MODULE_21__/* .analyticsService.experienceCardClick */ .I.experienceCardClick(analyticsPayload);
    };
    var linkConstructor = function() {
        return services_LinkService__WEBPACK_IMPORTED_MODULE_22__/* .linkService.getExperienceLink */ .k.getExperienceLink(experience.title, experience.id, locale);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "translate-z-0 absolute top-1.5 z-10 flex w-full items-center justify-between px-1.5",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_BBadge__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        className: "shadow-sm shadow-slate-500",
                        variant: "info",
                        contrasted: true,
                        children: t("vehicleImmediatelyReservable")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "transform cursor-pointer rounded-full duration-200 ease-in",
                        onClick: function() {
                            return toggleExperienceFavorite(experience.id);
                        },
                        tabIndex: -1,
                        role: "button",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_Favourited__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            isCurrentFavorited: isCurrentFavorited
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                href: linkConstructor(),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((styles_ExperienceCard_module_css__WEBPACK_IMPORTED_MODULE_24___default().container), containerClass),
                    target: isMobile ? "" : "_blank",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_ExperienceCard_module_css__WEBPACK_IMPORTED_MODULE_24___default().image),
                            onClick: sendAnalytics,
                            role: "presentation",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_12__/* .Swiper */ .tq, {
                                modules: [
                                    swiper__WEBPACK_IMPORTED_MODULE_9__/* .Pagination */ .tl
                                ],
                                pagination: {
                                    clickable: true,
                                    dynamicBullets: true,
                                    dynamicMainBullets: 5
                                },
                                spaceBetween: 0,
                                slidesPerView: 1,
                                children: experience.images.slice(0, 10).map(function(image, idx) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_12__/* .SwiperSlide */ .o5, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_BImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            src: image,
                                            height: 240,
                                            width: 300,
                                            alt: "".concat(experience.title, "-idx"),
                                            className: "object-cover",
                                            priority: isFirstImagePrioritized && idx === 0
                                        })
                                    }, "".concat(image, "-").concat(idx));
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "mb-1 flex items-start justify-between",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-sm",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "text-base font-medium",
                                                children: experience.title
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "flex shrink-0 items-center",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_RatingStar__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                commentCount: experience.reviewCount || 0,
                                                rating: experience.overallRating || 0,
                                                size: 16,
                                                small: true
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "text-sm text-slate-500",
                                    children: [
                                        "Tur s\xfcresi: ",
                                        hour ? "".concat(hour, " ").concat(t("experience.hour"), " ") : "",
                                        minute ? "".concat(minute, " ").concat(t("experience.minute"), " ") : ""
                                    ]
                                }),
                                !((ref = experience.sessionSummary) === null || ref === void 0 ? void 0 : ref.price) ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_CurrencyText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            className: "text-lg",
                                            price: experience.sessionSummary.price.amount,
                                            currency: experience.sessionSummary.price.currency
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "text-lg text-slate-500",
                                            children: [
                                                "/",
                                                t("units.headCount")
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ExperienceCard);


/***/ }),

/***/ 76185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85157);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18098);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28525);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95592);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32466);






var BRadio = function(_param) {
    var label = _param.label, onClick = _param.onClick, checked = _param.checked, attrs = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "label",
        "onClick",
        "checked"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: "jsx-758d016612c8f44d" + " " + (attrs.className || ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                        checked: checked,
                        onClick: onClick ? function() {
                            return onClick();
                        } : undefined
                    }, attrs), {
                        type: "radio",
                        className: "jsx-758d016612c8f44d" + " " + (attrs && attrs.className != null && attrs.className || "shadow")
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "jsx-758d016612c8f44d",
                        children: label
                    })
                ]
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "758d016612c8f44d",
                children: 'label.jsx-758d016612c8f44d{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;gap:.4rem;width:-webkit-max-content;width:-moz-max-content;width:max-content}input[type="radio"].jsx-758d016612c8f44d{position:relative;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;appearance:none;background-color:var(--clr-white);margin:0;width:1.2rem;height:1.2rem;border:1px solid var(--clr-primary-500);-webkit-border-radius:100%;-moz-border-radius:100%;border-radius:100%;cursor:pointer}input[type="radio"].jsx-758d016612c8f44d::before{content:"";position:absolute;background-color:var(--clr-primary-500);-webkit-border-radius:100%;-moz-border-radius:100%;border-radius:100%;top:50%;left:50%;width:.9rem;height:.9rem;opacity:0;-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);transform:translate(-50%,-50%);-webkit-box-shadow:inset 1rem 1rem var(--clr-primary-500);-moz-box-shadow:inset 1rem 1rem var(--clr-primary-500);box-shadow:inset 1rem 1rem var(--clr-primary-500)}input[type="radio"].jsx-758d016612c8f44d:checked::before{opacity:1}span.jsx-758d016612c8f44d{display:inline-block}'
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BRadio);


/***/ }),

/***/ 75765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85157);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18098);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var components_common_BButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87114);
/* harmony import */ var components_Experience_ExperienceCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24988);
/* harmony import */ var components_Vehicle_VehicleCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95614);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88082);








function isVehicle(vehicle) {
    return "vehicleId" in vehicle;
}
var VehicleList = function(param) {
    var vehicles = param.vehicles, onPageChange = param.onPageChange, isThereMorePage = param.isThereMorePage, location = param.location;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("common").t;
    var content = vehicles || [];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "grid grid-cols-1 justify-items-center gap-8 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4",
                children: content.map(function(c, i) {
                    return isVehicle(c) ? /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(components_Vehicle_VehicleCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, c), {
                        key: c.vehicleId + "-" + i,
                        location: location,
                        isFirstImagePrioritized: i < 4
                    })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Experience_ExperienceCard__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        experience: c,
                        isFirstImagePrioritized: i < 4
                    }, c.id + "-" + i);
                })
            }),
            isThereMorePage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_BButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                className: "mx-auto mt-6 block",
                onClick: onPageChange,
                children: t("seeMore")
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (VehicleList);


/***/ }),

/***/ 73351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32852);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88082);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32466);
/* harmony import */ var _TranslatedLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31468);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67320);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var hooks_useLocale__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74021);







var BBreadcrumb = function(param) {
    var breadcrumbItems = param.breadcrumbItems, wrapperClasses = param.wrapperClasses;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().t;
    var locale = (0,hooks_useLocale__WEBPACK_IMPORTED_MODULE_6__/* .useLocale */ .b)().locale;
    var isCurrent = function(idx) {
        return idx === breadcrumbItems.length - 1;
    };
    var breadcrumbSchema = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return '{"@context": "https://schema.org","@type": "BreadcrumbList","itemListElement": ['.concat(breadcrumbItems.map(function(item, idx) {
            var label = item.isTranslatable ? t(item.label) : item.label;
            var nonQPLink = item.link.split("?")[0];
            var prefixedLink = "https://www.teknevia.com".concat(nonQPLink);
            return '{"@type": "ListItem","position":'.concat(+idx + 1, ',"name":"').concat(label, '","item":"').concat(prefixedLink, '"}');
        }).join(","), "]}");
    }, [
        breadcrumbItems,
        t,
        locale
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
        "aria-label": "breadcrumbs",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_5___default()), {
                id: "breadcrumb-schema",
                type: "application/ld+json",
                strategy: "beforeInteractive",
                dangerouslySetInnerHTML: {
                    __html: breadcrumbSchema
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(wrapperClasses, "flex flex-wrap items-center gap-2"),
                children: breadcrumbItems.map(function(item, idx) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("breadcrumb-item text-xs md:text-sm", {
                            "text-primary-600 underline": !isCurrent(idx),
                            "text-black": isCurrent(idx)
                        }),
                        children: isCurrent(idx) ? item.isTranslatable ? t(item.label) : item.label : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TranslatedLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            href: item.link,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: item.isTranslatable ? t(item.label) : item.label
                            })
                        })
                    }, item.link);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BBreadcrumb);


/***/ }),

/***/ 54865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useBreadcrumbs; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36840);
/* harmony import */ var utils_slugify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27576);
/* harmony import */ var _useLocale__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74021);
/* harmony import */ var services_LinkService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41824);
/* harmony import */ var utils_getLocalePrefix__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14211);





function useBreadcrumbs() {
    var locale = (0,_useLocale__WEBPACK_IMPORTED_MODULE_1__/* .useLocale */ .b)().locale;
    var baseBreadcrumbItem = {
        label: "Teknevia",
        link: "/",
        isTranslatable: false
    };
    var defaultBreadcrumbs = [
        baseBreadcrumbItem
    ];
    var generateCategoryLinks = function(category, location) {
        var generatedBreadcrumbsArray = [
            {
                label: category.label,
                link: (0,utils_getLocalePrefix__WEBPACK_IMPORTED_MODULE_3__/* .getLocalePrefix */ .A)(locale) + category.value,
                isTranslatable: false
            }, 
        ];
        if (location) {
            var _loop = function(idx) {
                var labelKey = labelKeys[idx];
                var slugKey = slugKeys[idx];
                var locationLabel = location[labelKey] + " " + category.label;
                var _slugKey;
                var locationSlug = services_LinkService__WEBPACK_IMPORTED_MODULE_2__/* .linkService.generateCategoryLink */ .k.generateCategoryLink({
                    locale: locale,
                    locationSlug: (_slugKey = location[slugKey]) !== null && _slugKey !== void 0 ? _slugKey : (0,utils_slugify__WEBPACK_IMPORTED_MODULE_0__/* .slugifyText */ .E)("".concat(locationLabel)),
                    category: category.value
                });
                var hasAnySameLabel = generatedBreadcrumbsArray.some(function(item) {
                    return item.label === locationLabel;
                });
                if (!hasAnySameLabel) {
                    generatedBreadcrumbsArray.push({
                        label: locationLabel,
                        link: locationSlug,
                        isTranslatable: false
                    });
                }
                if (labelKey.includes(matchType)) {
                    return "break";
                }
            };
            var labelKeys = [
                "cityName",
                "regionName",
                "harborName"
            ];
            var slugKeys = [
                "citySlug",
                "regionSlug",
                "harborSlug"
            ];
            var matchType = location.matchType;
            for(var idx in labelKeys){
                var _ret = _loop(idx);
                if (_ret === "break") break;
            }
        }
        return generatedBreadcrumbsArray;
    };
    var generateOrganizationBreadcrumbs = function(subPage) {
        return [
            baseBreadcrumbItem,
            {
                label: "organizations:home.title",
                link: "/hizmetler",
                isTranslatable: true
            }, 
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(subPage ? [
            subPage
        ] : []));
    };
    return {
        defaultBreadcrumbs: defaultBreadcrumbs,
        onlyTekneViaBreadcrumb: defaultBreadcrumbs[0],
        generateCategoryLinks: generateCategoryLinks,
        generateOrganizationBreadcrumbs: generateOrganizationBreadcrumbs
    };
}


/***/ }),

/***/ 331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _category_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85157);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36840);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./src/components/Seo/SeoWrapper.tsx + 1 modules
var SeoWrapper = __webpack_require__(15010);
// EXTERNAL MODULE: ./src/components/common/BBreadcrumb.tsx
var BBreadcrumb = __webpack_require__(73351);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/components/Vehicle/VehicleList/VehicleList.tsx
var VehicleList = __webpack_require__(75765);
// EXTERNAL MODULE: ./src/components/common/BButton.tsx
var BButton = __webpack_require__(87114);
// EXTERNAL MODULE: ./src/components/common/TranslatedLink.tsx
var TranslatedLink = __webpack_require__(31468);
// EXTERNAL MODULE: ./src/components/Icons/illustrations/search/notFound.svg
var notFound = __webpack_require__(33716);
// EXTERNAL MODULE: ./src/hooks/useLocale.ts
var useLocale = __webpack_require__(74021);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(88082);
// EXTERNAL MODULE: ./src/services/LinkService.ts
var LinkService = __webpack_require__(41824);
;// CONCATENATED MODULE: ./src/components/Vehicle/VehicleList/VehicleListEmptyPlaceholder.tsx







var VehicleListEmptyPlaceholder = function(param) {
    var wrapperClasses = param.wrapperClasses;
    var t = (0,useTranslation/* default */.Z)("search").t;
    var locale = (0,useLocale/* useLocale */.b)().locale;
    var actionLink = LinkService/* linkService.generateCategoryLink */.k.generateCategoryLink({
        locale: locale
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: wrapperClasses,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col items-center gap-4 rounded-3xl border p-6 md:flex-row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(notFound/* default */.Z, {
                    className: "w-60"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-auto",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-xl font-medium",
                            children: t("notFound.title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-2 text-lg text-slate-500 ",
                            children: t("notFound.description")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TranslatedLink/* default */.Z, {
                            href: actionLink,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BButton/* default */.Z, {
                                    className: "mt-4",
                                    children: t("notFound.cta")
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var VehicleList_VehicleListEmptyPlaceholder = (VehicleListEmptyPlaceholder);

;// CONCATENATED MODULE: ./src/components/Vehicle/VehicleList/VehicleListTitle.tsx


var VehicleListTitle = function(param) {
    var dataLength = param.dataLength, title = param.title, breadcrumbs = param.breadcrumbs, wrapperClasses = param.wrapperClasses;
    var t = (0,useTranslation/* default */.Z)("search").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: wrapperClasses,
        children: [
            breadcrumbs,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-xl",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "mt-1 text-18px text-slate-500",
                children: t("subTitle", {
                    title: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-2 text-sm text-slate-500",
                children: t("itemsFound", {
                    count: dataLength
                })
            })
        ]
    });
};
/* harmony default export */ var VehicleList_VehicleListTitle = (VehicleListTitle);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18098);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(28525);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(32852);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/styles/BFormItem.module.css
var BFormItem_module = __webpack_require__(38086);
var BFormItem_module_default = /*#__PURE__*/__webpack_require__.n(BFormItem_module);
// EXTERNAL MODULE: ./src/styles/BSelect.module.css
var BSelect_module = __webpack_require__(6776);
var BSelect_module_default = /*#__PURE__*/__webpack_require__.n(BSelect_module);
;// CONCATENATED MODULE: ./src/components/Form/BSelect.tsx







function BSelect(_param) {
    var options = _param.options, selectedValue = _param.selectedValue, className = _param.className, attrs = (0,_object_without_properties/* default */.Z)(_param, [
        "options",
        "selectedValue",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("select", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        value: selectedValue,
        className: classnames_default()((BFormItem_module_default())["b-form-item"], (BSelect_module_default())["b-select"], className)
    }, attrs), {
        children: options.map(function(option) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                value: option.value,
                children: option.label
            }, option.value);
        })
    }));
}
/* harmony default export */ var Form_BSelect = (BSelect);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(21017);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(80072);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(59354);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(50132);
// EXTERNAL MODULE: ./src/states/useFilterStore.ts
var useFilterStore = __webpack_require__(79507);
;// CONCATENATED MODULE: ./src/components/Vehicle/VehicleList/Filter/VehicleListFilterSection.tsx

var VehicleListFilterSection = function(param) {
    var children = param.children, wrapperClass = param.wrapperClass, title = param.title, titleSide = param.titleSide;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: wrapperClass,
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-2 flex flex-wrap items-end gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-18px font-medium",
                        children: title
                    }),
                    titleSide
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: children
            })
        ]
    });
};
/* harmony default export */ var Filter_VehicleListFilterSection = (VehicleListFilterSection);

// EXTERNAL MODULE: ./src/components/Form/BCheckbox.tsx
var BCheckbox = __webpack_require__(34045);
// EXTERNAL MODULE: ./src/components/Form/BRadio.tsx
var BRadio = __webpack_require__(76185);
// EXTERNAL MODULE: ./src/hooks/useForm.ts
var useForm = __webpack_require__(36333);
// EXTERNAL MODULE: ./src/components/common/Modal.tsx + 2 modules
var Modal = __webpack_require__(71016);
// EXTERNAL MODULE: ./node_modules/@phosphor-icons/react/dist/lib/IconBase.es.js + 1 modules
var IconBase_es = __webpack_require__(52867);
;// CONCATENATED MODULE: ./node_modules/@phosphor-icons/react/dist/icons/Sliders.es.js
var r = Object.defineProperty, A = Object.defineProperties;
var c = Object.getOwnPropertyDescriptors;
var m = Object.getOwnPropertySymbols;
var v = Object.prototype.hasOwnProperty, d = Object.prototype.propertyIsEnumerable;
var Z = (V, e, t) => e in V ? r(V, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : V[e] = t, l = (V, e) => {
  for (var t in e || (e = {}))
    v.call(e, t) && Z(V, t, e[t]);
  if (m)
    for (var t of m(e))
      d.call(e, t) && Z(V, t, e[t]);
  return V;
}, n = (V, e) => A(V, c(e));



const E = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M68,102.06V40a12,12,0,0,0-24,0v62.06a36,36,0,0,0,0,67.88V216a12,12,0,0,0,24,0V169.94a36,36,0,0,0,0-67.88ZM56,148a12,12,0,1,1,12-12A12,12,0,0,1,56,148ZM164,88a36.07,36.07,0,0,0-24-33.94V40a12,12,0,0,0-24,0V54.06a36,36,0,0,0,0,67.88V216a12,12,0,0,0,24,0V121.94A36.07,36.07,0,0,0,164,88Zm-36,12a12,12,0,1,1,12-12A12,12,0,0,1,128,100Zm108,68a36.07,36.07,0,0,0-24-33.94V40a12,12,0,0,0-24,0v94.06a36,36,0,0,0,0,67.88V216a12,12,0,0,0,24,0V201.94A36.07,36.07,0,0,0,236,168Zm-36,12a12,12,0,1,1,12-12A12,12,0,0,1,200,180Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M80,136a24,24,0,1,1-24-24A24,24,0,0,1,80,136Zm48-72a24,24,0,1,0,24,24A24,24,0,0,0,128,64Zm72,80a24,24,0,1,0,24,24A24,24,0,0,0,200,144Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ react.createElement("path", { d: "M64,105V40a8,8,0,0,0-16,0v65a32,32,0,0,0,0,62v49a8,8,0,0,0,16,0V167a32,32,0,0,0,0-62Zm-8,47a16,16,0,1,1,16-16A16,16,0,0,1,56,152Zm80-95V40a8,8,0,0,0-16,0V57a32,32,0,0,0,0,62v97a8,8,0,0,0,16,0V119a32,32,0,0,0,0-62Zm-8,47a16,16,0,1,1,16-16A16,16,0,0,1,128,104Zm104,64a32.06,32.06,0,0,0-24-31V40a8,8,0,0,0-16,0v97a32,32,0,0,0,0,62v17a8,8,0,0,0,16,0V199A32.06,32.06,0,0,0,232,168Zm-32,16a16,16,0,1,1,16-16A16,16,0,0,1,200,184Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M84,136a28,28,0,0,1-20,26.83V216a8,8,0,0,1-16,0V162.83a28,28,0,0,1,0-53.66V40a8,8,0,0,1,16,0v69.17A28,28,0,0,1,84,136Zm52-74.83V40a8,8,0,0,0-16,0V61.17a28,28,0,0,0,0,53.66V216a8,8,0,0,0,16,0V114.83a28,28,0,0,0,0-53.66Zm72,80V40a8,8,0,0,0-16,0V141.17a28,28,0,0,0,0,53.66V216a8,8,0,0,0,16,0V194.83a28,28,0,0,0,0-53.66Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M62,106.6V40a6,6,0,0,0-12,0v66.6a30,30,0,0,0,0,58.8V216a6,6,0,0,0,12,0V165.4a30,30,0,0,0,0-58.8ZM56,154a18,18,0,1,1,18-18A18,18,0,0,1,56,154Zm78-95.4V40a6,6,0,0,0-12,0V58.6a30,30,0,0,0,0,58.8V216a6,6,0,0,0,12,0V117.4a30,30,0,0,0,0-58.8ZM128,106a18,18,0,1,1,18-18A18,18,0,0,1,128,106Zm102,62a30.05,30.05,0,0,0-24-29.4V40a6,6,0,0,0-12,0v98.6a30,30,0,0,0,0,58.8V216a6,6,0,0,0,12,0V197.4A30.05,30.05,0,0,0,230,168Zm-30,18a18,18,0,1,1,18-18A18,18,0,0,1,200,186Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M64,105V40a8,8,0,0,0-16,0v65a32,32,0,0,0,0,62v49a8,8,0,0,0,16,0V167a32,32,0,0,0,0-62Zm-8,47a16,16,0,1,1,16-16A16,16,0,0,1,56,152Zm80-95V40a8,8,0,0,0-16,0V57a32,32,0,0,0,0,62v97a8,8,0,0,0,16,0V119a32,32,0,0,0,0-62Zm-8,47a16,16,0,1,1,16-16A16,16,0,0,1,128,104Zm104,64a32.06,32.06,0,0,0-24-31V40a8,8,0,0,0-16,0v97a32,32,0,0,0,0,62v17a8,8,0,0,0,16,0V199A32.06,32.06,0,0,0,232,168Zm-32,16a16,16,0,1,1,16-16A16,16,0,0,1,200,184Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M60,108.29V40a4,4,0,0,0-8,0v68.29a28,28,0,0,0,0,55.42V216a4,4,0,0,0,8,0V163.71a28,28,0,0,0,0-55.42ZM56,156a20,20,0,1,1,20-20A20,20,0,0,1,56,156Zm76-95.71V40a4,4,0,0,0-8,0V60.29a28,28,0,0,0,0,55.42V216a4,4,0,0,0,8,0V115.71a28,28,0,0,0,0-55.42ZM128,108a20,20,0,1,1,20-20A20,20,0,0,1,128,108Zm100,60a28,28,0,0,0-24-27.71V40a4,4,0,0,0-8,0V140.29a28,28,0,0,0,0,55.42V216a4,4,0,0,0,8,0V195.71A28,28,0,0,0,228,168Zm-28,20a20,20,0,1,1,20-20A20,20,0,0,1,200,188Z" }))
  ]
]), M = (0,react.forwardRef)((V, e) => /* @__PURE__ */ react.createElement(IconBase_es/* default */.Z, n(l({ ref: e }, V), { weights: E })));
M.displayName = "Sliders";


// EXTERNAL MODULE: ./src/components/Form/BNumberInput.tsx
var BNumberInput = __webpack_require__(3644);
// EXTERNAL MODULE: ./src/components/Form/BLabelWrapper.tsx
var BLabelWrapper = __webpack_require__(38479);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(21395);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/services/SearchService.ts
var SearchService = __webpack_require__(36317);
// EXTERNAL MODULE: ./node_modules/query-string/index.js + 4 modules
var query_string = __webpack_require__(46527);
// EXTERNAL MODULE: ./src/enums/searchQueryKey.ts
var searchQueryKey = __webpack_require__(29429);
;// CONCATENATED MODULE: ./src/components/Vehicle/VehicleList/VehicleListFilter.tsx
























var VehicleListFilter = function(param) {
    var defaultVehicleType = param.defaultVehicleType;
    var t = (0,useTranslation/* default */.Z)("search").t;
    var asPath = (0,router.useRouter)().asPath;
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var ref1 = (0,react.useState)(false), isOptionsFetched = ref1[0], setIsOptionsFetched = ref1[1];
    var ref2 = (0,useFilterStore/* useFilterStore */.r)(), filterOptions = ref2.filterOptions, getFilterOptions = ref2.getFilterOptions, setFilterParams = ref2.setFilterParams, cleanFilterParams = ref2.cleanFilterParams;
    var defaultState = {
        onlyImmediatelyReservable: false,
        onlySuitableForWinter: false,
        canReserveForOneHour: false,
        rating: 0,
        vehicleTypes: defaultVehicleType ? [
            defaultVehicleType
        ] : [],
        usageConditions: [],
        facilities: [],
        priceRange: {
            min: (filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.priceRange.min) || 0,
            max: (filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.priceRange.max) || 0
        }
    };
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useForm/* useForm */.c)(defaultState), 2), state = ref3[0], dispatch = ref3[1];
    var setFiltersFromQuery = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var queryObj, filterQueryParams, filterOpts;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        queryObj = router_default().asPath.split("?")[1];
                        filterQueryParams = SearchService/* searchService.getFilterQueryParams */.u.getFilterQueryParams(queryObj);
                        filterOpts = filterOptions;
                        if (!(!isOptionsFetched || filterOptions !== null)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            getFilterOptions()
                        ];
                    case 1:
                        filterOpts = _state.sent();
                        setIsOptionsFetched(true);
                        _state.label = 2;
                    case 2:
                        if (filterOpts) {
                            dispatch({
                                type: "REPLACE_STATE",
                                payload: {
                                    onlyImmediatelyReservable: !!filterQueryParams.onlyImmediatelyReservable,
                                    canReserveForOneHour: !!filterQueryParams.canReserveForOneHour,
                                    rating: filterQueryParams.rating || defaultState.rating,
                                    vehicleTypes: filterQueryParams.vehicleTypes || defaultState.vehicleTypes,
                                    usageConditions: filterQueryParams.usageConditions || defaultState.usageConditions,
                                    facilities: filterQueryParams.facilities || defaultState.facilities,
                                    onlySuitableForWinter: !!filterQueryParams.onlySuitableForWinter,
                                    priceRange: {
                                        min: filterQueryParams.priceRange.min || filterOpts.priceRange.min,
                                        max: filterQueryParams.priceRange.max || filterOpts.priceRange.max
                                    }
                                }
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function setFiltersFromQuery() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        setFiltersFromQuery();
    }, [
        asPath
    ]);
    var _min;
    var hasMinRentalDurationOneHour = ((_min = filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.minimumRentDurationRange.min) !== null && _min !== void 0 ? _min : 0) <= 1;
    var ratingOptions = [
        4.5,
        4,
        3,
        2,
        1
    ];
    var setQueryParam = function() {
        var path = (router_default()).asPath;
        var allQueries = path.split("?")[1];
        var mappedQueries = query_string/* default.parse */.Z.parse(allQueries);
        var searchQueryKeys = Object.values(searchQueryKey/* SearchQueryKey */.B);
        var onlySearchQueries = Object.keys(mappedQueries).reduce(function(acc, key) {
            if (searchQueryKeys.includes(key)) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, key, mappedQueries[key]));
            }
            return acc;
        }, {});
        var searchQs = query_string/* default.stringify */.Z.stringify(onlySearchQueries);
        var qs = SearchService/* searchService.formatFiltersToQueryParamString */.u.formatFiltersToQueryParamString(state);
        path = path.split("?")[0] + "?";
        path += searchQs + (searchQs ? "&" : "");
        path += qs;
        router_default().replace(path);
    };
    var onSave = function() {
        setFilterParams(state);
        setShow(false);
        setQueryParam();
    };
    var onClear = function() {
        cleanFilterParams();
        dispatch({
            payload: defaultState,
            type: "REPLACE_STATE"
        });
        setShow(false);
    };
    var activeFilters = isOptionsFetched ? Object.entries(defaultState).reduce(function(acc, item) {
        return JSON.stringify(item[1]) !== JSON.stringify(state[item[0]]) ? acc + 1 : acc;
    }, 0) : 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BButton/* default */.Z, {
                onClick: function() {
                    return setShow(true);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(M, {
                            size: 24
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hidden md:block",
                            children: t("filter.title")
                        }),
                        activeFilters > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                "(",
                                activeFilters,
                                ")"
                            ]
                        }) : null
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                show: show,
                setShow: setShow,
                modalTitle: t("filter.title"),
                removeBottomMargin: true,
                removeSlideToClose: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "space-y-6 overflow-auto pr-3 pb-3 md:h-[70vh]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter_VehicleListFilterSection, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "space-y-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BCheckbox/* default */.Z, {
                                                checked: state.onlyImmediatelyReservable,
                                                name: "immediately-reserve",
                                                label: t("filter.onlyImmediatelyReservable.label"),
                                                onChange: function(e) {
                                                    return dispatch({
                                                        payload: e.target.checked,
                                                        type: "onlyImmediatelyReservable"
                                                    });
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BCheckbox/* default */.Z, {
                                                checked: state.onlySuitableForWinter,
                                                name: "winter-suitable",
                                                label: t("filter.isWinterSuitable.label"),
                                                onChange: function(e) {
                                                    return dispatch({
                                                        payload: e.target.checked,
                                                        type: "onlySuitableForWinter"
                                                    });
                                                }
                                            }),
                                            hasMinRentalDurationOneHour ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BCheckbox/* default */.Z, {
                                                checked: state.canReserveForOneHour,
                                                name: "min-rental-duration",
                                                label: t("filter.oneHourRentalVehicles.label"),
                                                onChange: function(e) {
                                                    return dispatch({
                                                        payload: e.target.checked,
                                                        type: "canReserveForOneHour"
                                                    });
                                                }
                                            }) : null
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter_VehicleListFilterSection, {
                                    title: t("filter.vehicleType.title"),
                                    children: filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.vehicleTypes.map(function(vt) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BCheckbox/* default */.Z, {
                                            value: vt,
                                            checked: state.vehicleTypes.includes(vt),
                                            label: t("common:boatTypes.".concat(vt)),
                                            className: "mt-2",
                                            name: "vehicle-type",
                                            onChange: function(e) {
                                                return dispatch({
                                                    payload: e.target.value,
                                                    type: "vehicleTypes",
                                                    isAppend: e.target.checked
                                                });
                                            }
                                        }, vt.toString());
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter_VehicleListFilterSection, {
                                    title: t("filter.priceRange.title"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-1 flex justify-between gap-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BLabelWrapper/* default */.Z, {
                                                label: t("common:multiSliderPlaceholders.min"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BNumberInput/* default */.Z, {
                                                    value: state.priceRange.min,
                                                    handleChange: function(e) {
                                                        dispatch({
                                                            payload: {
                                                                min: +e,
                                                                max: state.priceRange.max
                                                            },
                                                            type: "priceRange"
                                                        });
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BLabelWrapper/* default */.Z, {
                                                label: t("common:multiSliderPlaceholders.max"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BNumberInput/* default */.Z, {
                                                    value: state.priceRange.max,
                                                    handleChange: function(e) {
                                                        dispatch({
                                                            payload: {
                                                                min: state.priceRange.min,
                                                                max: +e
                                                            },
                                                            type: "priceRange"
                                                        });
                                                    },
                                                    placeholder: t("common:multiSliderPlaceholders.max")
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter_VehicleListFilterSection, {
                                    title: t("filter.rating.title"),
                                    titleSide: state.rating ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BButton/* default */.Z, {
                                        className: "text-sm underline hover:no-underline",
                                        priority: "none",
                                        onClick: function() {
                                            dispatch({
                                                payload: 0,
                                                type: "rating"
                                            });
                                        },
                                        children: t("filter.rating.sideTitle")
                                    }) : null,
                                    children: ratingOptions.map(function(ro) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BRadio/* default */.Z, {
                                            value: ro,
                                            checked: state.rating === ro,
                                            label: t("filter.rating.optionsLabel", {
                                                count: ro
                                            }),
                                            className: "mb-2",
                                            name: "rating",
                                            onChange: function(e) {
                                                return dispatch({
                                                    payload: +e.target.value,
                                                    type: "rating"
                                                });
                                            }
                                        }, ro.toString());
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter_VehicleListFilterSection, {
                                    title: t("filter.usageConditions.title"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "space-y-2",
                                        children: filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.usageConditions.map(function(uc) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BCheckbox/* default */.Z, {
                                                label: uc.label,
                                                value: uc.value,
                                                checked: state.usageConditions.includes(uc.value),
                                                name: "usage-condition",
                                                onChange: function(e) {
                                                    return dispatch({
                                                        payload: +e.target.value,
                                                        type: "usageConditions",
                                                        isAppend: e.target.checked
                                                    });
                                                }
                                            }, uc.value);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter_VehicleListFilterSection, {
                                    title: t("filter.facilities.title"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "space-y-2",
                                        children: filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.vehicleFacilities.map(function(vf) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BCheckbox/* default */.Z, {
                                                label: vf.label,
                                                value: vf.value,
                                                checked: state.facilities.includes(vf.value),
                                                name: "facilities",
                                                onChange: function(e) {
                                                    return dispatch({
                                                        payload: +e.target.value,
                                                        type: "facilities",
                                                        isAppend: e.target.checked
                                                    });
                                                }
                                            }, vf.value);
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-[env(safe-area-inset-bottom, 0px)] sticky bottom-0 left-0 w-full bg-white py-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fading-bottom after:-top-2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center justify-between gap-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BButton/* default */.Z, {
                                            variant: "secondary",
                                            priority: "outlined",
                                            onClick: onClear,
                                            children: t("filter.actions.clear")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BButton/* default */.Z, {
                                            onClick: onSave,
                                            children: t("filter.actions.save")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var VehicleList_VehicleListFilter = (VehicleListFilter);

// EXTERNAL MODULE: ./src/hooks/useComponentDidUpdate.ts
var useComponentDidUpdate = __webpack_require__(44773);
;// CONCATENATED MODULE: ./src/constants/defaultPagination.ts
var defaultPagination = {
    page: 0,
    size: 20
};

;// CONCATENATED MODULE: ./src/hooks/usePagination.ts



function usePagination() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useForm/* useForm */.c)(defaultPagination), 2), pagination = ref[0], paginationDispatch = ref[1];
    var incrementPage = function() {
        paginationDispatch({
            type: "page",
            payload: pagination.page + 1
        });
    };
    return {
        pagination: pagination,
        paginationDispatch: paginationDispatch,
        incrementPage: incrementPage
    };
}

;// CONCATENATED MODULE: ./src/enums/vehicleListSortOption.ts
var VehicleListSortOption;
(function(VehicleListSortOption) {
    VehicleListSortOption["BASE"] = "";
    VehicleListSortOption["PRICE_DESC"] = "pricingSummary.hourlyPrice,desc";
    VehicleListSortOption["PRICE_ASC"] = "pricingSummary.hourlyPrice,asc";
})(VehicleListSortOption || (VehicleListSortOption = {}));
var ExperienceListSortOption;
(function(ExperienceListSortOption) {
    ExperienceListSortOption["BASE"] = "";
    ExperienceListSortOption["PRICE_DESC"] = "sessions.price.amount,desc";
    ExperienceListSortOption["PRICE_ASC"] = "sessions.price.amount,asc";
})(ExperienceListSortOption || (ExperienceListSortOption = {}));

// EXTERNAL MODULE: ./node_modules/nprogress/nprogress.js
var nprogress = __webpack_require__(20917);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/index.js
var next_translate_routes = __webpack_require__(22742);
// EXTERNAL MODULE: ./src/hooks/useSearchFromQuery.ts
var useSearchFromQuery = __webpack_require__(12217);
;// CONCATENATED MODULE: ./src/hooks/useVehicleList.ts
















function useVehicleList(defaultVehicles, isLastPage, apiTotalElements, param) {
    var defaultVehicleType = param.defaultVehicleType, isExperience = param.isExperience;
    var t = (0,useTranslation/* default */.Z)().t;
    var router = (0,next_translate_routes.useRouter)();
    var ref = usePagination(), pagination = ref.pagination, incrementPage = ref.incrementPage;
    var ref1 = (0,react.useState)(defaultVehicles), vehicleList = ref1[0], setVehicleList = ref1[1];
    var isRouteChange = (0,react.useRef)(false);
    var filterParams = (0,useFilterStore/* useFilterStore */.r)().filterParams;
    var ref2 = (0,react.useState)(apiTotalElements), totalElements = ref2[0], setTotalElements = ref2[1];
    var getStateFromQuery = (0,useSearchFromQuery/* useSearchFromQuery */.o)().getStateFromQuery;
    var ref3 = (0,react.useState)(VehicleListSortOption.BASE), sortOption = ref3[0], setSortOption = ref3[1];
    var ref4 = (0,react.useState)(!isLastPage), isThereMorePage = ref4[0], setIsThereMorePage = ref4[1];
    var getVehiclesAndCheckPage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var isSort, paginationParams, _ref, location, searchQueries, response, experiences, vehicles;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isSort = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : false;
                        if (isRouteChange.current) return [
                            2
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            6,
                            7
                        ]);
                        paginationParams = {
                            page: pagination.page,
                            size: pagination.size,
                            sort: [
                                sortOption
                            ].filter(function(k) {
                                return k;
                            })
                        };
                        if (isSort) {
                            paginationParams = {
                                page: 0,
                                size: pagination.size * (pagination.page + 1),
                                sort: [
                                    sortOption
                                ].filter(function(k) {
                                    return k;
                                })
                            };
                        }
                        _ref = getStateFromQuery(), location = _ref.location, searchQueries = (0,_object_without_properties/* default */.Z)(_ref, [
                            "location"
                        ]);
                        nprogress.start();
                        if (!isExperience) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            SearchService/* searchService.getCompleteExperienceListWithFilter */.u.getCompleteExperienceListWithFilter(paginationParams, (0,_object_spread/* default */.Z)({}, (location === null || location === void 0 ? void 0 : location.slug) ? {
                                locationSlug: location.slug
                            } : {}, searchQueries))
                        ];
                    case 2:
                        experiences = _state.sent().experiences;
                        response = experiences;
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            SearchService/* searchService.getCompleteVehicleListWithFilter */.u.getCompleteVehicleListWithFilter(paginationParams, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (location === null || location === void 0 ? void 0 : location.slug) ? {
                                locationSlugs: [
                                    location.slug
                                ]
                            } : {}, filterParams), {
                                vehicleTypes: (0,_to_consumable_array/* default */.Z)(defaultVehicleType ? [
                                    defaultVehicleType
                                ] : []).concat((0,_to_consumable_array/* default */.Z)(filterParams.vehicleTypes || []))
                            }), (0,_object_spread/* default */.Z)({}, searchQueries))
                        ];
                    case 4:
                        vehicles = _state.sent().vehicles;
                        response = vehicles;
                        _state.label = 5;
                    case 5:
                        if (isSort) {
                            setVehicleList((0,_to_consumable_array/* default */.Z)(response.content));
                        } else {
                            setVehicleList(function(val) {
                                return (0,_to_consumable_array/* default */.Z)(val).concat((0,_to_consumable_array/* default */.Z)(response.content));
                            });
                        }
                        setTotalElements(response.totalElements);
                        setIsThereMorePage(!response.last);
                        return [
                            3,
                            7
                        ];
                    case 6:
                        nprogress.done();
                        return [
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function getVehiclesAndCheckPage() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        setVehicleList(defaultVehicles);
    }, [
        defaultVehicles
    ]);
    (0,react.useEffect)(function() {
        setIsThereMorePage(!isLastPage);
    }, [
        isLastPage
    ]);
    (0,react.useEffect)(function() {
        setTotalElements(apiTotalElements);
    }, [
        apiTotalElements
    ]);
    (0,useComponentDidUpdate/* useComponentDidUpdate */.d)(function() {
        getVehiclesAndCheckPage();
    }, [
        pagination.page
    ]);
    (0,useComponentDidUpdate/* useComponentDidUpdate */.d)(function() {
        getVehiclesAndCheckPage(true);
    }, [
        sortOption
    ]);
    (0,useComponentDidUpdate/* useComponentDidUpdate */.d)(function() {
        getVehiclesAndCheckPage(true);
    }, [
        filterParams
    ]);
    (0,react.useEffect)(function() {
        var onRouteChangeStart = function() {
            isRouteChange.current = true;
            setSortOption(VehicleListSortOption.BASE);
        };
        var onRouteChangeCompleted = function() {
            isRouteChange.current = false;
        };
        router.events.on("routeChangeStart", onRouteChangeStart);
        router.events.on("routeChangeComplete", onRouteChangeCompleted);
        return function() {
            router.events.off("routeChangeStart", onRouteChangeStart);
            router.events.off("routeChangeComplete", onRouteChangeCompleted);
        };
    }, []);
    var sortOptions = (0,react.useMemo)(function() {
        return [
            {
                label: t("search:sort.BASE"),
                value: isExperience ? ExperienceListSortOption.BASE : VehicleListSortOption.BASE
            },
            {
                label: t("search:sort.PRICE_ASC"),
                value: isExperience ? ExperienceListSortOption.PRICE_ASC : VehicleListSortOption.PRICE_ASC
            },
            {
                label: t("search:sort.PRICE_DESC"),
                value: isExperience ? ExperienceListSortOption.PRICE_DESC : VehicleListSortOption.PRICE_DESC
            }, 
        ];
    }, [
        t
    ]);
    return {
        incrementPage: incrementPage,
        vehicleList: vehicleList,
        isThereMorePage: isThereMorePage,
        sortOption: sortOption,
        setSortOption: setSortOption,
        sortOptions: sortOptions,
        totalElements: totalElements
    };
}

;// CONCATENATED MODULE: ./src/types/search.type.ts
function isSearchResponseExperience(apiVehicles) {
    return "experiences" in apiVehicles;
}

// EXTERNAL MODULE: ./src/states/useSearchState.ts
var useSearchState = __webpack_require__(72509);
// EXTERNAL MODULE: ./src/components/common/BBadge.tsx
var BBadge = __webpack_require__(24800);
;// CONCATENATED MODULE: ./src/services/HarborMappingService.ts
var harborMapping = {
    Bebek: [
        "Beşiktaş",
        "Arnavutk\xf6y",
        "Ortak\xf6y",
        "Kuru\xe7eşme"
    ],
    Kuruçeşme: [
        "Bebek",
        "Ortak\xf6y",
        "Beşiktaş"
    ],
    Ortaköy: [
        "Beşiktaş",
        "Arnavutk\xf6y",
        "Kuru\xe7eşme"
    ],
    Beşiktaş: [
        "Kabataş",
        "Karak\xf6y",
        "Ortak\xf6y",
        "Kuru\xe7eşme"
    ],
    Kabataş: [
        "Karak\xf6y",
        "Emin\xf6n\xfc",
        "Beşiktaş"
    ],
    Eminönü: [
        "Karak\xf6y",
        "Unkapanı",
        "Ayvansaray"
    ],
    Karaköy: [
        "Emin\xf6n\xfc",
        "Kabataş",
        "Unkapanı"
    ],
    Unkapanı: [
        "Emin\xf6n\xfc",
        "Karak\xf6y",
        "Ayvansaray"
    ],
    Ayvansaray: [
        "Unkapanı",
        "Emin\xf6n\xfc"
    ],
    Arnavutköy: [
        "Bebek",
        "Kuru\xe7eşme",
        "Sarıyer"
    ],
    Sarıyer: [
        "Kire\xe7burnu",
        "İstinye",
        "Arnavutk\xf6y"
    ],
    Kireçburnu: [
        "Sarıyer",
        "İstinye"
    ],
    İstinye: [
        "Kire\xe7burnu",
        "Sarıyer"
    ],
    // Büyükçekmece: ['Beylikdüzü', 'Esenyurt'],
    // Asian Side
    Kandilli: [
        "Beylerbeyi",
        "\xdcsk\xfcdar",
        "Anadolu Hisarı"
    ],
    Kuleli: [
        "Kandilli",
        "Anadolu Hisarı",
        "G\xf6ksu Deresi"
    ],
    "Anadolu Hisarı": [
        "G\xf6ksu Deresi",
        "Kuleli",
        "Beykoz"
    ],
    "G\xf6ksu Deresi": [
        "Anadolu Hisarı",
        "Beykoz"
    ],
    Beykoz: [
        "G\xf6ksu Deresi",
        "Anadolu Hisarı",
        "Beylerbeyi"
    ],
    Beylerbeyi: [
        "\xdcsk\xfcdar",
        "Kandilli",
        "Beykoz"
    ],
    Üsküdar: [
        "Harem",
        "Kadık\xf6y",
        "Beylerbeyi"
    ],
    Harem: [
        "\xdcsk\xfcdar",
        "Kadık\xf6y"
    ],
    Kadıköy: [
        "Harem",
        "Fenerbah\xe7e",
        "Kartal"
    ],
    Fenerbahçe: [
        "Kadık\xf6y",
        "K\xfc\xe7\xfckyalı"
    ],
    Küçükyalı: [
        "Kartal",
        "Fenerbah\xe7e"
    ],
    Kartal: [
        "K\xfc\xe7\xfckyalı"
    ]
};
/**
 * Helper function to get nearby harbors by harbor name
 * @param harborName The name of the harbor to find neighbors for
 * @returns Array of nearby harbor names or empty array if not found
 */ var getNearbyHarbors = function(harborName) {
    return harborName in harborMapping ? harborMapping[harborName] : [];
};
var harborMappingService = {
    getNearbyHarbors: getNearbyHarbors,
    harborMapping: harborMapping
};
/* harmony default export */ var HarborMappingService = ((/* unused pure expression or super */ null && (harborMappingService)));

// EXTERNAL MODULE: ./src/utils/slugify.ts
var slugify = __webpack_require__(27576);
;// CONCATENATED MODULE: ./src/components/Vehicle/VehicleList/VehicleListWrapper.tsx


















var VehicleListWrapper = function(param) {
    var title = param.title, apiVehicles = param.apiVehicles, breadcrumbItems = param.breadcrumbItems, defaultVehicleType = param.defaultVehicleType;
    var vehicleType = LinkService/* linkService.getRealVehicleCategory */.k.getRealVehicleCategory(defaultVehicleType);
    var locale = (0,useLocale/* useLocale */.b)().locale;
    var content, last, apiTotalElements;
    if (isSearchResponseExperience(apiVehicles)) {
        content = apiVehicles.experiences.content;
        last = apiVehicles.experiences.last;
        apiTotalElements = apiVehicles.experiences.totalElements;
    } else {
        content = apiVehicles.vehicles.content;
        last = apiVehicles.vehicles.last;
        apiTotalElements = apiVehicles.vehicles.totalElements;
    }
    var ref = useVehicleList(content !== null && content !== void 0 ? content : [], last !== null && last !== void 0 ? last : true, apiTotalElements, {
        defaultVehicleType: vehicleType,
        isExperience: defaultVehicleType === "EXPERIENCE"
    }), vehicleList = ref.vehicleList, incrementPage = ref.incrementPage, isThereMorePage = ref.isThereMorePage, setSortOption = ref.setSortOption, sortOption = ref.sortOption, sortOptions = ref.sortOptions, totalElements = ref.totalElements;
    var allSearchData = (0,useSearchState/* useSearchState */.X)().allSearchData;
    var locations = (0,react.useMemo)(function() {
        var ref;
        var linkCategory = Object.entries(LinkService/* linkService.categoryMap */.k.categoryMap).find(function(a) {
            return a[1] === defaultVehicleType;
        })[0];
        var link = (ref = LinkService/* linkService.categoryLinkTranslations.find */.k.categoryLinkTranslations.find(function(a) {
            return a.tr === linkCategory;
        })) === null || ref === void 0 ? void 0 : ref[locale];
        var linkTitle = LinkService/* linkService.categoryLinkTitleTranslations */.k.categoryLinkTitleTranslations[linkCategory][locale];
        if (apiVehicles.location) {
            var data = [];
            if (apiVehicles.location.matchType === "harbor") {
                var _data;
                var harborName = apiVehicles.location.harborName;
                var nearbyHarbors = harborMappingService.getNearbyHarbors(harborName);
                (_data = data).push.apply(_data, (0,_to_consumable_array/* default */.Z)(nearbyHarbors.map(function(nearbyHarbor) {
                    return {
                        name: "".concat(nearbyHarbor, " ").concat(linkTitle),
                        link: LinkService/* linkService.generateCategoryLink */.k.generateCategoryLink({
                            category: link,
                            locale: locale,
                            locationSlug: (0,slugify/* slugifyText */.E)(nearbyHarbor)
                        })
                    };
                })));
            }
            if ([
                "region",
                "city",
                "country"
            ].includes(apiVehicles.location.matchType)) {
                var _data1;
                var ref1, ref2, ref3;
                var slug = apiVehicles.location["".concat(apiVehicles.location.matchType, "Slug")];
                (_data1 = data).push.apply(_data1, (0,_to_consumable_array/* default */.Z)(((ref3 = (ref1 = allSearchData.find(function(a) {
                    return a.slug === slug;
                })) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.children) === null || ref2 === void 0 ? void 0 : ref2.filter(function(a) {
                    return a.slug !== slug;
                })) === null || ref3 === void 0 ? void 0 : ref3.map(function(a) {
                    return {
                        name: "".concat(a.name, " ").concat(linkTitle),
                        link: LinkService/* linkService.generateCategoryLink */.k.generateCategoryLink({
                            category: link,
                            locale: locale,
                            locationSlug: a.slug
                        })
                    };
                })) || []));
            }
            return data;
        } else {
            return allSearchData.reduce(function(acc, item) {
                var data = {
                    name: "".concat(item.name, " ").concat(linkTitle),
                    link: LinkService/* linkService.generateCategoryLink */.k.generateCategoryLink({
                        category: link,
                        locale: locale,
                        locationSlug: item.slug
                    })
                };
                if (!acc.find(function(a) {
                    return a.link === data.link;
                })) {
                    acc.push(data);
                }
                return acc;
            }, []);
        }
    }, [
        allSearchData,
        apiVehicles.location,
        defaultVehicleType,
        locale
    ]);
    var readableLocation = (0,react.useMemo)(function() {
        if (apiVehicles.location && apiVehicles.location.matchType === "harbor") {
            return apiVehicles.location.harborName;
        }
        return undefined;
    }, [
        apiVehicles.location
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BBreadcrumb/* default */.Z, {
                breadcrumbItems: breadcrumbItems,
                wrapperClasses: "mb-4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-6 items-center gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleList_VehicleListTitle, {
                        wrapperClasses: "col-span-6 md:col-span-3 row-span-1",
                        dataLength: totalElements,
                        title: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: " col-span-1 col-end-7 row-start-2 justify-self-end md:row-start-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_BSelect, {
                            className: "w-203 self-center",
                            options: sortOptions,
                            selectedValue: sortOption,
                            onChange: function(e) {
                                return setSortOption(e.target.value);
                            }
                        })
                    }),
                    defaultVehicleType !== "EXPERIENCE" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-1 row-start-2 md:col-span-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleList_VehicleListFilter, {
                            defaultVehicleType: vehicleType
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-8",
                children: vehicleList.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleList/* default */.Z, {
                    vehicles: vehicleList,
                    onPageChange: incrementPage,
                    isThereMorePage: isThereMorePage,
                    location: readableLocation
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleList_VehicleListEmptyPlaceholder, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-12 flex flex-wrap justify-center gap-4",
                children: defaultVehicleType !== "EXPERIENCE" && locations.map(function(l) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TranslatedLink/* default */.Z, {
                        href: l.link,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            title: l.name,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BBadge/* default */.Z, {
                                className: "border border-transparent text-sm hover:border-slate-900 md:text-base",
                                variant: "secondary",
                                children: l.name
                            })
                        })
                    }, l.link);
                })
            })
        ]
    });
};
/* harmony default export */ var VehicleList_VehicleListWrapper = (VehicleListWrapper);

// EXTERNAL MODULE: ./src/hooks/useBreadcrumbs.ts
var useBreadcrumbs = __webpack_require__(54865);
// EXTERNAL MODULE: ./src/services/LocalizationService.ts
var LocalizationService = __webpack_require__(55389);
// EXTERNAL MODULE: ./src/components/common/BImage.tsx
var BImage = __webpack_require__(69327);
;// CONCATENATED MODULE: ./src/pages/[category]/index.tsx












var RentalBoatsByType = function(param) {
    var paginatedVehicleWithBreadcrumbs = param.paginatedVehicleWithBreadcrumbs, slugTranslations = param.slugTranslations, category = param.category, helmetSettings = param.helmetSettings, content = param.content, breadcrumbCategory = param.breadcrumbCategory, title = param.title;
    LocalizationService/* localizationService.slugTranslations */.R.slugTranslations = (0,_object_spread/* default */.Z)({}, slugTranslations);
    var locale = (0,useLocale/* useLocale */.b)().locale;
    var ref = (0,useBreadcrumbs/* useBreadcrumbs */.h)(), defaultBreadcrumbs = ref.defaultBreadcrumbs, generateCategoryLinks = ref.generateCategoryLinks;
    var breadcrumbItems = function() {
        return (0,_to_consumable_array/* default */.Z)(defaultBreadcrumbs).concat((0,_to_consumable_array/* default */.Z)(generateCategoryLinks(breadcrumbCategory, paginatedVehicleWithBreadcrumbs.location)));
    }();
    var isExperience = isSearchResponseExperience(paginatedVehicleWithBreadcrumbs);
    var bannerLink = LinkService/* linkService.getCategoryLinkOption */.k.getCategoryLinkOption(null, locale, "EXPERIENCE");
    var bannerImageLink = "https://cdn.teknevia.com/storefront/common/experience-breakfast-banner-".concat(locale, ".png");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SeoWrapper/* default */.Z, {
        helmetSettings: helmetSettings,
        content: content,
        children: [
            !isExperience ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TranslatedLink/* default */.Z, {
                href: bannerLink.value,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative mx-auto mb-6 block w-full md:mb-0 md:w-[28rem]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BImage/* default */.Z, {
                            src: bannerImageLink,
                            layout: "responsive",
                            width: 171,
                            height: 50
                        })
                    })
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleList_VehicleListWrapper, {
                title: title,
                apiVehicles: paginatedVehicleWithBreadcrumbs,
                breadcrumbItems: breadcrumbItems,
                defaultVehicleType: category
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _category_ = (RentalBoatsByType);


/***/ }),

/***/ 70379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ getExperienceDurationByTime; }
/* harmony export */ });
/* harmony import */ var services_DateService__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49163);

function getExperienceDurationByTime(duration) {
    var dayjs = services_DateService__WEBPACK_IMPORTED_MODULE_0__/* .dateService.getDayjs */ .o.getDayjs();
    var d = dayjs.duration(duration, "m");
    return {
        hour: d.hours(),
        minute: d.minutes()
    };
}


/***/ }),

/***/ 6776:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"b-select":"BSelect_b-select__MgxBw"};

/***/ }),

/***/ 97890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"ExperienceCard_container__mL7aZ","image":"ExperienceCard_image__7tyRu","dash":"ExperienceCard_dash__rPXnr","star":"ExperienceCard_star__8HzwV"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3457,5867,1643,9774,2888,179], function() { return __webpack_exec__(30047); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);